import { render, staticRenderFns } from "./HostSpecsForm.vue?vue&type=template&id=37ba374d&scoped=true"
import script from "./HostSpecsForm.vue?vue&type=script&lang=js"
export * from "./HostSpecsForm.vue?vue&type=script&lang=js"
import style0 from "./HostSpecsForm.vue?vue&type=style&index=0&id=37ba374d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ba374d",
  null
  
)

export default component.exports